import React from 'react';
import {Provider} from "components/parameter/ParameterContext";
import {ParameterList} from "components/parameter/ParameterList";

export const Parameters = () => {

    return (
        <Provider>
            <ParameterList/>
        </Provider>
    );
}
